import React from 'react';
import { find } from 'lodash-es';
import { useSelector } from 'react-redux';

import { filterCtChannels, getNumberOfVideosPerRow } from 'utils/common';
import { viewRangeSelector, channelsSelector } from 'common/selectors';

import { VideoItem } from 'components/video-item/index';

const getVideoUrl = (video, baseUrl, channels) => {
  if (baseUrl) {
    return `${baseUrl}/${video.id}`;
  }

  const ctChannels = filterCtChannels(video.channels, channels);
  if (ctChannels.length === 0) {
    return '/';
  }
  const channel = find(channels, (c) => c.id === ctChannels[0].id);
  baseUrl = `/channel/${channel.id}/${channel.slug}/1`;
  return `${baseUrl}/${video.id}`;
};

export const CarouselItem = ({ video, baseUrl, thumbnailRef, carouselRef, withRelatedVideos }) => {
  const channels = useSelector(channelsSelector);
  const viewRange = useSelector(viewRangeSelector);

  const numberOfVideosPerRow = getNumberOfVideosPerRow(viewRange, withRelatedVideos);
  const containerPadding = 30;
  const containerWidth = carouselRef.current ? carouselRef.current.getBoundingClientRect().width : 0;
  const width = containerWidth && (containerWidth + containerPadding) / numberOfVideosPerRow;

  return (
    <VideoItem
      data-e2e={`video-carousel-item__${video.id}`}
      video={video}
      url={getVideoUrl(video, baseUrl, channels)}
      className={'video-carousel__video-carousel-item'}
      showRating
      thumbnailRef={thumbnailRef}
      width={width}
    />
  );
};
